const UIStrategy = require('./ui_strategy');
const UIStrategyAvailable = require('./ui_strategy_available');
const UIStrategyPending = require('./ui_strategy_pending');
const UIStrategyAvailableAtTheAirport = require('./ui_strategy_available_at_the_airport');
const UIStrategyAvailableAtTheAirportSumo4416 = require('./ui_strategy_available_at_the_airport_sumo_4416');
const UIStrategyUnavailable = require('./ui_strategy_unavailable');
const UIStrategyCancelled = require('./ui_strategy_cancelled');
const postBookingUtils = require('../../../utils/postbooking/js/utils');
const postBookingSeatsUtils = require('../../../utils/postbooking/js/seats');

const getUIStrategyClassForContractBooking = (bookingInfo = {}, catalogueData = {}) => {
    let UIStrategyClass;
    const isAvailable = Odigeo.AB.isPostBookingBagsAndSeatsCtaAlwaysEnabled || postBookingSeatsUtils.isAvailable(bookingInfo, catalogueData);
    if (isAvailable) {
        UIStrategyClass = UIStrategyAvailable;
    } else if (
        postBookingUtils.areAllFlightDeparted(bookingInfo)
        || postBookingSeatsUtils.haveAllTravellersAttachedInAllAvailableSegments(bookingInfo)
        || postBookingUtils.haveAnyFlightCancelled(bookingInfo)) {
        UIStrategyClass = UIStrategyUnavailable;
    } else {
        UIStrategyClass = Odigeo.AB.isSeatsAndBagsSupportArea ? UIStrategyAvailableAtTheAirportSumo4416 : UIStrategyAvailableAtTheAirport;
    }
    if (Odigeo.AB.isSeatsAndBagsSupportArea) {
        Odigeo.trigger('ancillaries:bagsAndSeatsAvailability', {product: 'seats', showLink: catalogueData?.responseOK && !isAvailable});
    }


    return UIStrategyClass;
};

UIStrategy.factory = (bookingInfo, catalogueData, view, templates, keys, constants) => {
    let UIStrategyClass;

    const status = bookingInfo.bookingStatus;
    switch (status) {
        case 'CONTRACT':
            UIStrategyClass = getUIStrategyClassForContractBooking(bookingInfo, catalogueData);
            break;
        case 'HOLD':
        case 'REQUEST':
        case 'RETAINED':
            UIStrategyClass = UIStrategyPending;
            break;
        case 'INIT':
        case 'PENDING':
        case 'REJECTED':
        case 'DIDNOTBUY':
        default:
            UIStrategyClass = UIStrategyCancelled;
            break;
    }

    return new UIStrategyClass(bookingInfo, view, templates, keys, constants);
};

module.exports = UIStrategy;
